// eslint-disable-next-line import/no-extraneous-dependencies
import { Plugin } from '@nuxt/types';
import apiClient from '@/shared/scripts/api_client';

const apiClientPlugin: Plugin = (_, inject) => {
  inject('api_client', apiClient);
};

export default apiClientPlugin;
